import { Role } from "../../domain/SecuritySlice/Role";
import ApiWrapperAuthenticated from "../Common/ApiWrapperAuthenticated";

export class RolesRepository 
    extends ApiWrapperAuthenticated<Role> {
    constructor() {
        super('authorization/roles/');
    }
}